import { Core as YubinBangoCore } from 'yubinbango-core';

/**
 * 
 * @param {object} address
 * @param {string} zipCode
 */
export function zipCodeAutoComplete(address, zipCode)
{
    new YubinBangoCore(zipCode, function(addr) {
        address.address_1 = addr.region_id;
        address.address_2 = addr.locality + addr.street;
    })
}